module.exports = __webpack_public_path__ + "static/media/book-cover-journal-escribli.185b41c2.jpg";